import React from "react";

import ContentCore from "../../../core/workingContent";

const TaskListShared = () => {
  return (
    <ContentCore />
  )
}

export default TaskListShared